import React from "react";
import "../App.css";
export default function Header() {
  return (
    <div className="Header">
      <img
        style={{
          objectFit: "cover",
          transform: "scaleX(-1)",
        }}
        width="100%"
        height="100%"
        src="https://images.unsplash.com/photo-1566930753949-fc3ef91faf3a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80"
      />
    </div>
  );
}
